<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">淘宝插旗工具</span>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :span="24">
          <span style="color: red;font-size: smaller">
            使用淘宝工具之前请咨询使用方法， 并确认授权。
            <div>（注：请使用绑定的淘宝商家的账号）</div>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 2%;">
        <el-col :span="24">
          <el-button type="primary" size="small" @click="confirmAsscetAuthor">确认授权</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 2%;">
        <el-col :span="24">
          <el-form ref="flagForm" :model="flagForm" label-width="100px">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="交易备注" prop="tradeMemo">
                  <el-input v-model="flagForm.tradeMemo" placeholder="交易备注"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="旗帜颜色" prop="tradeFlag">
                  <el-select v-model="flagForm.tradeFlag" clearable placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="淘宝订单号" prop="platefromOrderNum">
                  <el-input v-model="flagForm.platefromOrderNum" placeholder="淘宝平台订单号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="淘宝账号" prop="plateformAccountName">
                  <el-input v-model="flagForm.plateformAccountName" placeholder="淘宝订单使用的淘宝账号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="text-align: center">
              <el-col :span="12">
                <el-button type="primary" @click="addFlag">添加插旗</el-button>
              </el-col>
              <el-col :span="12">
                <el-button type="warning" @click="updateFlag" disabled>修改旗帜</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </el-card>
</div>
</template>

<script>
import {addplateformflag, getTaobaoAuthorUrl, updateplateformflag} from "../../api/b2cbusiness/b2c_tasklist";

export default {
name: "BusinessTools",
  data(){
  return{
    flagForm:{
      tradeFlag:0
    },
    options:[
      {
        label:"0(灰色)",
        value:0
      },
      {
        label:"1(红色)",
        value:1
      },
      {
        label:"2(黄色)",
        value:2
      },
      {
        label:"3(绿色)",
        value:3
      },
      {
        label:"4(蓝色)",
        value:4
      },
      {
        label:"5(粉红色)",
        value:5
      },
    ]
  }
  },
  methods:{
    confirmAsscetAuthor(){
      getTaobaoAuthorUrl().then(res=>{
        if (res.success){
          window.open(res.data, '_blank');
        }
      });
    },
    resetFlagForm(){
      for(let item in this.flagForm){
        if (typeof this.flagForm[item]==='string'){
          this.flagForm[item]='';
        } else if (this.flagForm[item] instanceof Array) {
          this.flagForm[item]=[];
        } else{
          this.flagForm[item]=null
        }
      }
    },
    addFlag(){
      addplateformflag(this.flagForm).then(res=>{
        if (res.success){
          this.$message.success(res.data)
          this.resetFlagForm()
        }
      }).catch(err => {
        this.resetFlagForm()
        this.$message({message: err.message, type: 'error'});
      });
    },
    updateFlag(){
      updateplateformflag(this.flagForm).then(res=>{
        if (res.success){
          this.$message.success(res.data)
          this.resetFlagForm()
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
